import styled from 'styled-components';
import { TooltipWrapper } from '@spa/shared/components/Tooltip/styles';
export var Wrapper = /*#__PURE__*/styled.section.withConfig({
  componentId: "sc-b3fn9o-0"
})(["width:100%;h2{font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;color:", ";margin-bottom:", ";}"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.contract.description.color;
}, function (props) {
  return props.theme.space(5);
});
export var Item = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-b3fn9o-1"
})(["display:flex;", " margin:", " 0;&:last-of-type{margin-bottom:0;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(2);
}, function (props) {
  return props.theme.space(5);
});
export var ItemDescription = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-b3fn9o-2"
})(["display:flex;font-family:'IntervalNextReg',sans-serif;flex-direction:column;h4{font-weight:500;font-size:", ";line-height:", ";display:flex;color:", ";", "{margin-left:", ";}& + p{font-weight:400;font-size:", ";line-height:", ";color:", ";}}a{font-weight:500;font-size:", ";line-height:", ";margin-top:", ";}"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.contract.title.color;
}, TooltipWrapper, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.contract.title.color;
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.space(1);
});